import React, { useEffect } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { get } from "lodash";

import { FormField } from "../../../../sharedComponents/formField";
import { required } from "../../../../constants/formValidators";
import { getIngredientWeightsList, updateRecipeIngredient } from "../../../../store/actions";

const EditIngredientsForm = ({
	handleSubmit,
	submitting,
	togglePanel,
	ingredientWeights,
	getIngredientWeightsList,
	initialValues,
	updateRecipeIngredient,
	onUpdate
}) => {
	useEffect(() => {
		initialValues && initialValues.ingredient_data && getIngredientWeightsList(initialValues.ingredient_data.id);
	}, [initialValues, getIngredientWeightsList]);

	const validateForm = (values) => {
		if (values.id) {
			const parameters = {
				recipe: values.recipe,
				ingredient: values.ingredient,
				measure: values.measure_data ? values.measure_data.id : null,
				quantity: Number(values.quantity),
				main: values.main ? values.main : false,
				seq: values.seq
			};
			updateRecipeIngredient(values.id, parameters, () => onUpdate(values));
		} else {
			onUpdate(values);
		}
	};
	return initialValues && initialValues.ingredient_data && initialValues.ingredient_data.id ? (
		<div className="d-flex flex-column min-h-100 flex-fill">
			<h5 className="text-primary-dark mb-2">Ingredient name</h5>
			<div>{initialValues.ingredient_data.name && initialValues.ingredient_data.name !== "" ? initialValues.ingredient_data.name : initialValues.ingredient_data.long_desc}</div>
			<form onSubmit={handleSubmit(validateForm)} className="d-flex w-100 flex-column flex-fill">
				<div className="flex-fill">
					<h5 className="text-primary-dark mt-4 mb-2">Decide how much of this ingredient</h5>
					<div className="row">
						<div className="col-3">
							<label className="form-label m-0">Main</label>
							<Field name="main" type="checkbox" formGroupClass="m-0 mt-2" component={FormField} />
						</div>
						<div className="col-4">
							<Field
								name="seq"
								label="Seq"
								type="number"
								min="1"
								formGroupClass="m-0"
								component={FormField}
								validate={[required]}
							/>
						</div>
						<div className="col-5">
							<Field
								name="quantity"
								label="Quantity"
								type="number"
								min="0.01"
								step="0.01"
								formGroupClass="m-0"
								component={FormField}
								validate={[required]}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Field
								name="measure_data.id"
								label="Weights"
								type="select"
								options={ingredientWeights}
								viewValue={"measure"}
								formGroupClass="m-0"
								component={FormField}
							/>
						</div>
					</div>
				</div>
				<div className="d-flex align-items-end">
					<div className="flex-fill text-right">
						<button className="btn btn-default" type="button" onClick={() => togglePanel(false)}>
							Cancel
						</button>
						<button className="btn btn-primary-dark" type="submit" disabled={submitting}>
							Save
						</button>
					</div>
				</div>
			</form>
		</div>
	) : (
			<div className="alert alert-info text-center">No data found!</div>
		);
};

const mapStateToProps = (state) => {
	return {
		ingredientWeights: get(state, "AddRecipe.getIngredientWeights.results", [])
	};
};

const mapDispatchToProps = {
	getIngredientWeightsList,
	updateRecipeIngredient
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "EditIngredientsForm",
		enableReinitialize: true
	})(EditIngredientsForm)
);
